import { Column } from 'components/Blocks';
import { BugReportButton } from './BugReport';
import { SuggestionsButton } from './Suggestions';

export function HelpCentral() {
  return (
    <Column gap="2" className="mt-auto w-full">
      <BugReportButton />

      <SuggestionsButton />
    </Column>
  );
}
